import pmsInstance from '../instance'
import { ChargeSubmission } from './types'

export const createCharge = (id: string, payload: ChargeSubmission) => {
	return pmsInstance.post(`/chargeSessions/${id}/charge`, payload)
}

export const cancelChargeSession = (id: string) => {
	return pmsInstance.post(`/chargeSessions/${id}/cancel`)
}
